import React from 'react'
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import { Message, ConversationItem } from './type'
import './ChatSession.scss'

// interface Message {
//   content: string
//   role: 'user' | 'bot'
//   timestamp: string
//   _id: string
// }

// interface ConversationItem {
//   message: Message
//   _id: string
// }

interface Chat {
  _id: string
  bot_created_date: string
  botid: string
  chatid: string
  conversation: ConversationItem[]
  __v: number
}

interface ChatDetailsProps {
  chatId: string
  date: string
  messages: ConversationItem[]
  onClose: () => void
  onRefresh: () => void
}


const ChatDetails: React.FC<ChatDetailsProps> = ({ chatId, date, messages, onClose, onRefresh }) => {
  const messagesWithContent = messages.filter(m => m.message.content)

  return (
    <Modal show={true} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>Chat Details: {date}</Modal.Title>
      </Modal.Header>
      <Modal.Body className='chat-modal-body'>
        {messagesWithContent.map((message) => (
          <div
            key={message._id}
            className={`message ${message.message.role === 'user' ? 'user' : 'bot'}`}
          >
            <p className='message-content'>{message.message.content}</p>
          </div>
        ))}
      </Modal.Body>
      <Modal.Footer>
        <Button variant='secondary' onClick={onClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  )
}


export default ChatDetails
